import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { api } from '../services/api';

const DEFAULT_PRICE_ID = import.meta.env.VITE_STRIPE_PRICE_QUARTERLY || import.meta.env.VITE_STRIPE_PRICE_MONTHLY || '';

interface UpgradeButtonProps {
  label?: string;
  priceId?: string;
}

export function UpgradeButton({ label, priceId = DEFAULT_PRICE_ID }: UpgradeButtonProps) {
  const { t } = useTranslation();
  const displayLabel = label ?? t('app.upgradeButton.defaultLabel');
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    if (!priceId) {
      // Fallback: redirect to marketing pricing section
      window.location.href = '/#pricing';
      return;
    }

    setLoading(true);
    try {
      const { url } = await api.createCheckoutSession(priceId);
      if (url) {
        window.location.href = url;
      }
    } catch (err) {
      console.error('Failed to create checkout session:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <span className="upgrade-btn-wrap">
      <button
        className="btn btn-primary btn-sm upgrade-btn"
        onClick={handleClick}
        disabled={loading}
      >
        {loading ? t('app.upgradeButton.loading') : displayLabel}
      </button>
      <span className="upgrade-cancel-note">{t('app.upgradeButton.cancelNote')}</span>
    </span>
  );
}
